import React from "react";
import { getDogImagePath, getImagePath } from "../../utils/images";
export interface HeroImageProps
	extends React.ImgHTMLAttributes<HTMLImageElement> {
	src: string;
	alt: string;
	isDog?: boolean;
}
const HeroImage: React.FC<HeroImageProps> = ({ src, alt, isDog, ...rest }) => {
	const getImage = isDog ? getDogImagePath : getImagePath;
	const webpSrc = `${src}.webp`; // e.g /images/dogs/1234.jpg.webp

	return (
		<picture>
			<source
				src={getImage("400x300", webpSrc)}
				media="(max-width: 600px)"
				type="image/webp"
			/>
			<source
				src={getImage("800x600", webpSrc)}
				media="(max-width: 1024px)"
				type="image/webp"
			/>
			<source
				src={getImage("1080x810", webpSrc)}
				media="(max-width: 1200px)"
				type="image/webp"
			/>
			<source
				srcSet={getImage("1440x1080", webpSrc)}
				media="(max-width: 8000px)"
			/>
			<img {...rest} src={getImage("800x600", src)} alt={alt} />
		</picture>
	);
};

export default HeroImage;
